export default __webpack_public_path__ + "assets/pdf/FT_Válvula Borboleta.d3aad63f.pdf";